<template>
    <div>
        <oil-register-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='1'" :key="formType"></oil-register-form>
        <commitment-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='2'" :key="formType"></commitment-form>
        <fire-control-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='12'" :key="formType"></fire-control-form>
        <machinery-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='13'" :key="formType"></machinery-form>
        <oil-intention-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='18'" :key="formType"></oil-intention-form>
        <partners-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='20'" :key="formType"></partners-form>
        <person-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='23'" :key="formType"></person-form>
        <consignment-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='100'" :key="formType"></consignment-form>
        <safety-evaluate-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='5'" :key="formType"></safety-evaluate-form>
        <thunder-form @close="close()" @on-success="formSuccess" :formId="formId" :prop="chileProps" v-if="formType=='15'" :key="formType"></thunder-form>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { Message } from 'element-ui'
  import OilRegisterForm from "../../admin/sysForm/oilRegister.vue";
  import PersonForm from "../../admin/sysForm/certifiedIegalPerson.vue";
  import FireControlForm from "../../admin/sysForm/fireControlList .vue";
  import MachineryForm from "../../admin/sysForm/machineryList.vue";
  import OilIntentionForm from "../../admin/sysForm/oilIntention.vue";
  import PartnersForm from "../../admin/sysForm/partnersInformation.vue";
  import CommitmentForm from "../../admin/sysForm/commitment.vue";
  import consignmentForm from "../../admin/sysForm/consignment.vue";
  import safetyEvaluateForm from "../../admin/sysForm/safetyEvaluate.vue";
  import thunderForm from "../../admin/sysForm/thunder.vue";

  export default {
    name: 'formView',
    components:{ 
        OilRegisterForm,PersonForm,FireControlForm,MachineryForm,OilIntentionForm,PartnersForm,CommitmentForm,
        consignmentForm, safetyEvaluateForm, thunderForm
    },
    props:["formId","formType","prop","preview"],
    data() {
      return {
          chileProps:{}
      }
    },
    created() {
        let prop = this.prop || {};
        if(!prop.hasOwnProperty("preview")){
            prop = Object.assign(prop,{preview: this.preview || false })
        }
        this.chileProps = {...prop};
        if(!this.formType){
            Message({
                message: '材料配置错误，未找到表单!',
                type: 'error',
                duration: 3 * 1000
            })
        }
    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {
        formSuccess:function(data){
            this.$emit("success", data || {});
        },
        close(){
            this.$emit('close')
        }
    }
  }
</script>
